export const Instructions = () => {
  return (
    <div className="container">
      <h1 style={{textAlign: "center"}}>Coaching Styles and the Five Elements</h1>
      <hr />
      <h2>Description</h2>
      <p>
        We each have a primary element, though all are present. Consider it a style, a preference, a default or
        typical way we do things and relate to others. This can help us identify our style as a coach.
      </p>
      <p>
        Why does it help to know our primary element/style? Because it can help us better utilize our talents
        and therefore thrive in our endeavors. It can help us maximize our performance and hone in on
        techniques to better help others. When we understand what motivates and drives us, we can harness
        that power and use its driving force to move us forward. It aligns us with our passions and strengths, and
        can help prevent frustration.
      </p>
      <h2>Instructions</h2>
      <p>For each statement below, enter a number between 0 and 3:</p>
      <div className="d-flex">
        <ul>
          <li>0 – <em>not like me</em></li>
          <li>1 – <em>somewhat like me</em></li>
          <li>2 – <em>strongly like me</em></li>
          <li>3 – <em>always like me</em></li>
        </ul>
      </div>
      <p>Each statement corresponds to an element. The score you enter for each statement will add up for the element the statement corresponds to.</p>
      <p>After completing all of the statements, you can see the result at the bottom.</p>
      <p>At the very bottom, click the <strong>Save</strong> button to download an HTML file with your results to your download folder.</p>
      {/* <h2>Controls</h2>
      <h3>Keyboard and mouse</h3> 
      <p>Click between the plus (+) and minus (-) - <em>Move between statements</em></p>
      <p>Use the number keys - <em>Change values</em></p>
      <h3>Keyboard</h3>
      <p>Up and down arrow keys - <em>Increase and descrease values</em></p>
      <p>Tab and shift+Tab - <em>Move between statements</em></p>
      <h3>Mouse / Tablet</h3>
      <p>Pluse (+) and minus (-) - <em>Increase and descrease values</em></p> */}
    </div>
  )
}